var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotateAnticlockwise(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 81 86",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "5px"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.005 -7.386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m32.8 18.98c7.37-3.63 15.72-4.76 23.78-3.23 20.37 3.88 33.93 23.83 30.05 44.2s-23.83 33.93-44.2 30.05-33.93-23.83-30.05-44.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "39.79 26.06 27.72 21.96 31.75 10.11"
  })), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(45)",
    x: 47.601,
    y: -10.364,
    width: 28.29,
    height: 28.29
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateAnticlockwise);
export default __webpack_public_path__ + "static/media/rotate-anticlockwise.b867acb8.svg";
export { ForwardRef as ReactComponent };